import './App.css';
import talleres from './data/talleres';
import agenda from './data/agenda';

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

const slugTaller = (nombre) =>
  nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
const tallerIds = new Set(talleres.map(t => slugTaller(t.ponente)));

const faqData = [
  {
    "question": "¿Cómo consigo mis boletos para el Amores de Garra Fest?",
    "answer": "¡Muy fácil! Recuerda escuchar MVS 102.5, EXA Fm o La Mejor FM donde estaremos regalando entradas."
  },
  {
    "question": "¿Las conferencias, talleres y actividades tienen algún costo?",
    "answer": "¡Ninguno! Pero recuerda que algunas de las actividades tienen cupo limitado así que te recomendamos que te registres en esta misma página para asegurar tu lugar."
  },
  {
    "question": "¿Puedo llevar a toda mi familia?",
    "answer": "¡Claro! Este es un evento familiar. Toda la familia está invitada."
  },
  {
    "question": "¿Hay estacionamiento?",
    "answer": "El Centro de Exposiciones y Congresos de la UNAM tiene estacionamiento limitado. Sin embargo, hay algunos estacionamientos cercanos, como el de UNIVERSUM Museo de las Ciencias, Pabellon nacional de la diversidad y el Centro Cultural Universitario."
  },
  {
    "question": "¿Hay una agenda con todas las actividades del día?",
    "answer": "Poco a poco vamos a estar actualizando las actividades que tenemos ¡hay algunas espectaculares! Te recomendamos que sigas las redes sociales de Amores de Garra y escuches las estaciones de MVS Radio."
  },
  {
    "question": "¿A qué hora puedo asistir?",
    "answer": "Todo el día tendremos actividades, desde las 10 hasta las 6 de la tarde. Puedes asistir a la hora que prefieras."
  },
  {
    "question": "¿Puedo llevar otro animal de compañía (aves, hurones, etc)?",
    "answer": "¡Oh no! Este es un evento todo perro y todo gato, así que por su propia seguridad no podrás ingresar si llevas un animalito de otra especie ¡déjalo en su casa para que no se estrese!"
  },
  {
    "question": "¿Hay alguna restricción de razas para ciertas actividades?",
    "answer": "Este es un evento para todos los perros y gatos. Pero toma en cuenta que si tu perrito es muy poco sociable o agresivo con otros perros, tal vez no se la pase tan bien en este evento ¡Esperamos un gran número de peluditos!"
  },
  {
    "question": "¿Puedo ingresar alimentos o bebidas?",
    "answer": "Amores de Garra Fest contará con un área para que puedas comprar snacks, bebidas y cosas deliciosas. Si quieres llevar una botella con agua o premios pequeños para tu animal de compañía, puedes hacerlo."
  },
  {
    "question": "¿Qué requisitos me piden para ingresar con mi perro o gato?",
    "answer": "Deben contar con collar, correa y, en el caso de gatos, transportadora."
  }
];

// Talleres estáticos para el formulario de registro
const talleresEstaticos = [
  {
    dia: 'Sábado',
    hora: '12:00',
    nombre: 'Manos a la garra: crea juguetes caseros para tu gato'
  },
  {
    dia: 'Sábado', 
    hora: '13:00',
    nombre: 'Veterinario forense por un día'
  },
  {
    dia: 'Sábado',
    hora: '14:00', 
    nombre: 'Buen manejo en el paseo de perros'
  },
  {
    dia: 'Sábado',
    hora: '15:00',
    nombre: 'Primeros auxilios'
  },
  {
    dia: 'Domingo',
    hora: '11:30',
    nombre: 'Mejora la relación con tu perro a través de la correa'
  },
  {
    dia: 'Domingo',
    hora: '12:30',
    nombre: 'Manejo de todos los días en armonía'
  },
  {
    dia: 'Domingo',
    hora: '13:30',
    nombre: 'Nutre, no sólo alimentes a tu gato'
  },
  {
    dia: 'Domingo',
    hora: '14:30',
    nombre: 'Primeros Auxilios'
  }
];

// Componente de Registro
const RegistroForm = ({ onSubmit, onClose, conferenciasSabado, conferenciasDomingo, talleresSabado, talleresDomingo, actividadesSabado = [], actividadesDomingo = [] }) => {
  const [form, setForm] = useState({
    nombreCompleto: '',
    correo: '',
    fechaNacimiento: '',
    telefono: '',
    terminos: false,
    whatsapp: false,
    animal: '',
    taller1: '', // Sábado
    taller2: ''  // Domingo
  });
  const [formError, setFormError] = useState({});
  const [formSuccess, setFormSuccess] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [qrUrl, setQrUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef();

  const validateForm = () => {
    const errors = {};
    if (!form.nombreCompleto.trim()) errors.nombreCompleto = 'El nombre es obligatorio.';
    if (!form.correo.match(/^\S+@\S+\.\S+$/)) errors.correo = 'Correo inválido.';
    if (!form.fechaNacimiento) errors.fechaNacimiento = 'La fecha de nacimiento es obligatoria.';
    if (!form.telefono.match(/^\d{10}$/)) errors.telefono = 'El teléfono debe tener exactamente 10 dígitos.';
    if (!form.terminos) errors.terminos = 'Debes aceptar los términos.';
    if (form.whatsapp && !form.telefono) errors.whatsapp = 'Debes ingresar tu teléfono para WhatsApp.';
    return errors;
  };

  const handleFormChange = e => {
    const { name, value, type, checked, multiple, options } = e.target;
    if (multiple) {
      // Para selects múltiples
      const selected = Array.from(options).filter(o => o.selected).map(o => o.value);
      if (selected.length <= 3) {
        setForm(f => ({ ...f, [name]: selected }));
      }
      // Si selecciona más de 3, no actualiza el estado (o puedes mostrar un mensaje)
    } else {
      setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
    }
  };

  const handleFormSubmit = async e => {
    e.preventDefault();
    setFormSuccess('');
    setQrUrl(null);
    setIsLoading(true);
    const errors = validateForm();
    setFormError(errors);
    if (Object.keys(errors).length > 0) {
      setIsLoading(false);
      return;
    }
    try {
      const formToSend = { ...form, lada: '+52' };
      //const res = await fetch('http://localhost:3001/api/registro', { 
      const res = await fetch('https://api.amoresdegarrafest.com/api/registro', {
      method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formToSend)
      });
      const data = await res.json();
      if (data.status === 'ok') {
        setFormSuccess('¡Registro exitoso!\n\nEsté QR es tu acceso al evento, presentalo en la entrada.');
        setQrUrl(data.qr);
        setForm({
          nombreCompleto: '', correo: '', fechaNacimiento: '', telefono: '', terminos: false, whatsapp: false, animal: '', taller1: '', taller2: ''
        });
        formRef.current?.reset();
        if (onSubmit) onSubmit();
      } else if (data.status === 'duplicated') {
        setFormSuccess('Este correo ya ha sido registrado.');
      } else {
        setFormSuccess('Hubo un error. Intenta nuevamente.');
      }
      setShowPopup(true);
    } catch {
      setFormSuccess('Hubo un error. Intenta nuevamente.');
      setShowPopup(true);
    } finally {
      setIsLoading(false);
    }
  };



  // ... dentro de RegistroForm
  const descargarQR = async () => {
    if (!qrUrl) return;
    try {
      const response = await fetch(qrUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'QR-AmoresDeGarra.png';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert('No se pudo descargar el QR. Intenta de nuevo.');
    }
  };

  return (
    <form ref={formRef} onSubmit={handleFormSubmit} className="registro-form">
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="nombreCompleto">Nombre completo*</label>
          <input type="text" id="nombreCompleto" name="nombreCompleto" value={form.nombreCompleto} onChange={handleFormChange} autoComplete="name" />
          {formError.nombreCompleto && <span className="form-error">{formError.nombreCompleto}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="correo">Correo electrónico*</label>
          <input type="email" id="correo" name="correo" value={form.correo} onChange={handleFormChange} autoComplete="email" />
          {formError.correo && <span className="form-error">{formError.correo}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="fechaNacimiento">Fecha de nacimiento*</label>
          <input type="date" id="fechaNacimiento" name="fechaNacimiento" value={form.fechaNacimiento} onChange={handleFormChange} />
          {formError.fechaNacimiento && <span className="form-error">{formError.fechaNacimiento}</span>}
        </div>
        <div className="form-group telefono-group">
          <label htmlFor="telefono">Teléfono*</label>
          <div className="telefono-flex">
            <input type="tel" id="telefono" name="telefono" value={form.telefono} onChange={handleFormChange} autoComplete="tel" placeholder="Ej. 5512345678" />
          </div>
          {formError.telefono && <span className="form-error">{formError.telefono}</span>}
        </div>

        <div className="form-group full-width">
          <label htmlFor="animal">Animal de compañía <span className="animal-leyenda">(perro o gato, +6 meses)</span></label>
          <select id="animal" name="animal" value={form.animal || ''} onChange={handleFormChange} className="select-animal">
            <option value="">Ninguno</option>
            <option value="perro">Perro</option>
            <option value="gato">Gato</option>
          </select>
        </div>
        {/* Select único de talleres - COMENTADO TEMPORALMENTE */}
        {/* <div className="form-group full-width">
          <label htmlFor="taller1">Selecciona Taller Sábado o Domingo</label>
          <select id="taller1" name="taller1" value={form.taller1} onChange={handleFormChange} className="select-animal">
            <option value="">Ninguno</option>
            {talleresEstaticos.map((t, idx) => (
              <option key={idx} value={`${t.dia} - ${t.hora} - ${t.nombre}`}>{`${t.dia} - ${t.hora} - ${t.nombre}`}</option>
            ))}
          </select>
        </div> */}
        {/* Leyenda de cupo - COMENTADA TEMPORALMENTE */}
        {/* <div className="form-group full-width" style={{marginTop: '-0.5em', marginBottom: '1em'}}>
          <span style={{fontSize: '0.95em', color: '#b36b00', fontWeight: 'bold'}}>El registro de taller está sujeto a cupo el día del evento.</span>
        </div> */}
      </div>
      <div className="form-group form-checkbox">
        <label>
          <input type="checkbox" name="terminos" checked={form.terminos} onChange={handleFormChange} />
          Acepto el <a href="https://mvsnoticias.com/p/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">aviso de privacidad</a>*
        </label>
        {formError.terminos && <span className="form-error">{formError.terminos}</span>}
      </div>
      <div className="form-group form-checkbox">
        <label>
          <input type="checkbox" name="whatsapp" checked={form.whatsapp} onChange={handleFormChange} />
          Acepto recibir comunicaciones de Amores de Garra por WhatsApp al dar mi número
        </label>
        {formError.whatsapp && <span className="form-error">{formError.whatsapp}</span>}
      </div>
      <button type="submit" className="registro-btn" disabled={isLoading}>
        {isLoading ? 'Enviando...' : 'REGISTRARSE'}
      </button>
      {isLoading && (
        <div className="registro-loader">Enviando datos, por favor espera...</div>
      )}
      {showPopup && (
        <div className="registro-popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="registro-popup" onClick={e => e.stopPropagation()}>
            <button className="cerrar-popup" onClick={() => setShowPopup(false)} aria-label="Cerrar">&times;</button>
            <div className="registro-popup-mensaje">
              <h3>Registro</h3>
              <p>{formSuccess}</p>
              {qrUrl && (
                <div className="registro-qr-block">
                  <img src={qrUrl} alt="QR de acceso" className="registro-qr-img" />
                  <div className="registro-qr-acciones">
                    <button type="button" onClick={descargarQR} className="registro-qr-descargar">Descargar QR</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

// Banderas para mostrar/ocultar secciones
const SHOW_PRESENTADO = false;
const SHOW_PONENTES = false;
const SHOW_AGENDA = false;
const SHOW_REGISTRO = false;

const logosPresentado = [
  'royal-blanco.png',
  'bbf-blanco.png',
  'boing-blanco.png',
  'viven-blanco.png',
  'pfi-blanco.png',
  'neuro-blanco.png',
  'marlovet-blanco.png',
  'kong_solid_logo_BLANCO.png',
  'animall.png',
  'benji-y-lola.png',
  'churu.png',
  'inaba.png',
  'nutrial.png',
  'han.png',
  "hican.png",
  "husse.png",
  "koblenz.png",
  "musiccenter.png",
  "pecto2.png",
  "petco.png",
  "petgel.png",
  "uteca.png",
  "granpet.png",
  "tasty.png",
  "honda.png",
  "iztacalco.png",
  "infinity.png"
];

const logosAsociaciones = [
  '18a_BLANCO.png',
 /* f */
  'logo_fcm_BLANCO.png',
  'LOGO-PNA_BLANCO.png',
  'logo-unam_BLANCO.png',
  'UNIDADCANINA_BLANCO.png',
  'armada-bl.png',
  'defensa-bl.png',
  'marina-bl.jpeg',
  /* 'USAR-MARINA.png' */
];

export default function App() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isSticky, setSticky] = useState(false);
  const [ponenteSeleccionado, setPonenteSeleccionado] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [actividadSeleccionada, setActividadSeleccionada] = useState(null);
  const [ponentesData, setPonentesData] = useState([]);
  const [actividadesSabado, setActividadesSabado] = useState([]);
  const [actividadesDomingo, setActividadesDomingo] = useState([]);
  const [actividadesZonaFelina, setActividadesZonaFelina] = useState([]);

  // Función para manejar errores de imagen de manera más robusta
  const handleImageError = (e, nombrePonente) => {
    const img = e.target;
    const currentSrc = img.src;
    
    // Intentar con el formato alternativo
    if (currentSrc.endsWith('.jpg')) {
      img.src = currentSrc.replace('.jpg', '.png');
      return; // No marcar como fallback aún, esperar a ver si .png funciona
    } else if (currentSrc.endsWith('.png')) {
      // Si ya intentamos con .png y falló, entonces mostrar placeholder
      img.style.display = 'none';
      const placeholder = img.nextSibling;
      if (placeholder) {
        placeholder.style.display = 'flex';
      }
      return;
    }
    
    // Si no es .jpg ni .png, mostrar placeholder
    img.style.display = 'none';
    const placeholder = img.nextSibling;
    if (placeholder) {
      placeholder.style.display = 'flex';
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll robusto para cualquier ancla del menú, incluso si el contenido tarda en cargar o el hash cambia
  useEffect(() => {
    let lastHash = window.location.hash;
    let attempts = 0;
    let maxAttempts = 10; // 10 intentos (2 segundos en total)
    let intervalId = null;

    function scrollToHash() {
      if (!window.location.hash) return;
      const sectionId = window.location.hash.replace('#', '');
      const header = document.querySelector('.header');
      const offset = (header ? header.offsetHeight : 70) + 30;
      const section = document.getElementById(sectionId);
      if (section) {
        const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
        clearInterval(intervalId);
      } else if (attempts < maxAttempts) {
        attempts++;
      } else {
        clearInterval(intervalId);
      }
    }

    function startScrollWatcher() {
      if (intervalId) clearInterval(intervalId);
      attempts = 0;
      intervalId = setInterval(scrollToHash, 200);
    }

    // Primer intento al cargar
    if (window.location.hash) {
      startScrollWatcher();
    }

    // Escuchar cambios de hash
    const onHashChange = () => {
      if (window.location.hash !== lastHash) {
        lastHash = window.location.hash;
        startScrollWatcher();
      }
    };
    window.addEventListener('hashchange', onHashChange);

    return () => {
      window.removeEventListener('hashchange', onHashChange);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  // Cargar datos de agenda y ponentes desde JSON
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const [actividadesSab, actividadesDom, ponentes, zonaFelina] = await Promise.all([
          fetch('/data/actualizado/eventos_sabado.json').then(res => res.json()),
          fetch('/data/actualizado/eventos_domingo.json').then(res => res.json()),
          fetch('/data/ponentes.json').then(res => res.json()),
          fetch('/data/actualizado/eventos_zona_felina.json').then(res => res.json())
        ]);
        
        setActividadesSabado(actividadesSab);
        setActividadesDomingo(actividadesDom);
        setActividadesZonaFelina(zonaFelina);
        // Procesar ponentes para agregar fotos y redes sociales
        const ponentesProcesados = ponentes
          .filter(ponente => ponente.semblanza !== null) // Solo mostrar ponentes con semblanza
          .map(ponente => ({
            ...ponente,
            profesion: null,
            color: null,
            foto: `/img/ponentes/${ponente.nombre}.jpg`,
            resumen: ponente.semblanza,
            instagram: "", // Comentado por ahora
            facebook: "", // Comentado por ahora
            tiktok: "", // Comentado por ahora
            youtube: "" // Comentado por ahora
          }));
        setPonentesData(ponentesProcesados);
      } catch (error) {
        console.error('Error cargando datos:', error);
      }
    };

    cargarDatos();
  }, []);

  // Agregar listener para cerrar popup con Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setActividadSeleccionada(null);
        setPonenteSeleccionado(null);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const abrirPopupPonente = (ponente) => {
    setPonenteSeleccionado(ponente);
  };

  const cerrarPopupPonente = () => {
    setPonenteSeleccionado(null);
  };

  // Función para procesar texto con saltos de línea
  const procesarTextoConSaltos = (texto) => {
    if (!texto) return '';
    return texto.split('\n\n').map((parrafo, index) => (
      <React.Fragment key={index}>
        {parrafo}
        {index < texto.split('\n\n').length - 1 && <><br /><br /></>}
      </React.Fragment>
    ));
  };

  // Smooth scroll con offset para el menú
  const handleMenuClick = (e, sectionId) => {
    e.preventDefault();
    setMenuOpen(false); // Cierra el menú hamburguesa si está abierto
    const header = document.querySelector('.header');
    const offset = header ? header.offsetHeight + 10 : 70; // 10px extra de margen
    const section = document.getElementById(sectionId);
    if (section) {
      const top = section.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <div className="app">
      <header className={`header ${isSticky ? 'sticky' : ''}`}>
        <nav className="nav-menu">
          <div className="logo-menu desktop-only">
            <img
              src={isSticky ? '/img/logo-blanco.png' : '/img/logo-negro.png'}
              alt="Logo Amores de Garra"
              className="logo-img"
            />
          </div>
          <ul className="desktop-only">
            <li><a href="#hero" onClick={e => handleMenuClick(e, 'hero')}>Inicio</a></li>
            <li><a href="#agenda-evento" onClick={e => handleMenuClick(e, 'agenda-evento')}>Agenda</a></li>
            <li><a href="#talleres" onClick={e => handleMenuClick(e, 'talleres')}>Talleres</a></li>
            {SHOW_PONENTES && <li><a href="#ponentes" onClick={e => handleMenuClick(e, 'ponentes')}>Ponentes</a></li>}
            {SHOW_AGENDA && <li><a href="#agenda" onClick={e => handleMenuClick(e, 'agenda')}>Agenda</a></li>}
            {SHOW_REGISTRO && <li><a href="#registro" onClick={e => handleMenuClick(e, 'registro')}>Registro</a></li>}
          </ul>
          <button className="hamburger-btn mobile-only" onClick={() => setMenuOpen(true)} aria-label="Abrir menú">
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
          </button>
        </nav>
        {menuOpen && (
          <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}>
            <div className="mobile-menu" onClick={e => e.stopPropagation()}>
              <button className="close-mobile-menu" onClick={() => setMenuOpen(false)} aria-label="Cerrar menú">&times;</button>
              <ul>
                <li><a href="#hero" onClick={e => handleMenuClick(e, 'hero')}>Inicio</a></li>
                <li><a href="#agenda-evento" onClick={e => handleMenuClick(e, 'agenda-evento')}>Agenda</a></li>
                <li><a href="#talleres" onClick={e => handleMenuClick(e, 'talleres')}>Talleres</a></li>
                {SHOW_PONENTES && <li><a href="#ponentes" onClick={e => handleMenuClick(e, 'ponentes')}>Ponentes</a></li>}
                {SHOW_AGENDA && <li><a href="#agenda" onClick={e => handleMenuClick(e, 'agenda')}>Agenda</a></li>}
                {SHOW_REGISTRO && <li><a href="#registro" onClick={e => handleMenuClick(e, 'registro')}>Registro</a></li>}
                  </ul>
              <div className="mobile-menu-logo">
                <img src="/img/logo-blanco.png" alt="Logo Amores de Garra" />
              </div>
            </div>
          </div>
        )}
      </header>

      <main>
        <section className="hero" id="hero">
          <img src={require('./assets/images/header.jpg')} alt="Amores de Garra Fest, 17 y 18 de octubre, Explanada de la Alcaldía Benito Juárez, Ciudad de México" className="hero-img" />
        </section>



        <section id="agenda-evento" className="agenda-evento">
          <h2>Agenda</h2>
          <div className="agenda-dias">
            {agenda.map(d => (
              <div key={d.dia} className="agenda-dia">
                <h3>{d.dia}</h3>
                <ul>
                  {d.items.map(it => (
                    <li key={it.hora} className={`agenda-item agenda-${it.tipo}`}>
                      <div className="agenda-hora">
                        <strong>{it.hora}</strong>
                        <span>{it.duracion}</span>
                      </div>
                      <div className="agenda-info">
                        <p className="agenda-titulo">{it.titulo}</p>
                        {it.ponente && <p className="agenda-ponente">{it.ponente}</p>}
                        {it.tipo === 'taller' && tallerIds.has(slugTaller(it.ponente)) && (
                          <a className="agenda-ver" href={`#taller-${slugTaller(it.ponente)}`}>Ver tallerista →</a>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section id="talleres" className="talleres-info">
          <h2>Talleres</h2>
          {['Sábado 17 de octubre', 'Domingo 18 de octubre'].map(dia => (
            <div key={dia} className="talleres-dia">
              <h3>{dia}</h3>
              <div className="talleres-info-grid">
                {talleres.filter(t => t.dia === dia).map(t => (
                  <article className="taller-card" id={`taller-${slugTaller(t.ponente)}`} key={t.taller}>
                    <div className="taller-foto">
                      <img
                        src={`/img/talleristas/${t.foto}`}
                        alt={t.ponente}
                        onError={e => { e.currentTarget.style.display = 'none'; e.currentTarget.nextSibling.style.display = 'flex'; }}
                      />
                      <div className="taller-foto-placeholder" style={{ display: 'none' }}>
                        <span>{t.ponente.charAt(0)}</span>
                      </div>
                    </div>
                    <div className="taller-body">
                      {t.horario && <p className="taller-horario">{t.horario}</p>}
                      <h4>{t.taller}</h4>
                      <p className="taller-ponente">{t.ponente}</p>
                      <p className="taller-descripcion">{t.descripcion}</p>
                      <details>
                        <summary>Sobre {t.ponente}</summary>
                        <p>{t.semblanza}</p>
                      </details>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </section>

        {SHOW_PONENTES && (
          <section id="ponentes" className="ponentes">
            <h2>Ponentes</h2>
            <div className="ponentes-grid">
              {ponentesData.map((ponente, i) => (
                <div
                  key={i}
                  className="ponente"
                  style={{ '--ponente-color': ponente.color }}
                  onClick={() => abrirPopupPonente(ponente)}
                  tabIndex={0}
                  role="button"
                  onKeyPress={e => { if (e.key === 'Enter') abrirPopupPonente(ponente); }}
                >
                  <div className="foto-ponente">
                    <img 
                      src={ponente.foto} 
                      alt={ponente.nombre}
                      onError={(e) => handleImageError(e, ponente.nombre)}
                    />
                    <div className="foto-placeholder" style={{display: 'none'}}>
                      <span>{ponente.nombre.charAt(0)}</span>
                    </div>
                  </div>
                  <p className="ponente-nombre">{ponente.nombre}</p>
                  <p className="ponente-profesion">{ponente.profesion}</p>
                </div>
              ))}
            </div>
          </section>
        )}

        {SHOW_AGENDA && (
          <>
          <br></br>
          <br></br>
            <div className="agenda-dia sabado" id="agenda">
              <p className="agenda-leyenda">Agenda sujeta a cambios</p>
              <h3>Sábado 02 de Agosto</h3>
              
              {/* Conferencias Sábado */}
              <div className="agenda-seccion">
                <h4>Conferencias</h4>
                <div className="agenda-lista">
                  {actividadesSabado
                    .filter(actividad => actividad.tipo === 'conferencia')
                    .map((actividad, i) => (
                      <React.Fragment key={`conf-sabado-${i}`}>
                        <div className="hora">
                          {actividad.hora} - {(() => {
                            const [hora, minuto] = actividad.hora.split(':').map(Number);
                            const totalMin = hora * 60 + minuto + 30;
                            const horaFin = Math.floor(totalMin / 60);
                            const minutoFin = totalMin % 60;
                            return `${horaFin.toString().padStart(2, '0')}:${minutoFin.toString().padStart(2, '0')}`;
                          })()}
                        </div>
                        <div 
                          className="actividad conferencia"
                          onClick={() => setActividadSeleccionada(actividad)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="actividad-info">{actividad.ponente} – {actividad.nombre}</div>
                        </div>
                      </React.Fragment>
                    ))}
                </div>
              </div>

              {/* Talleres Sábado */}
              <div className="agenda-seccion">
                <h4>Talleres</h4>
                <div className="agenda-lista">
                  {actividadesSabado
                    .filter(actividad => actividad.tipo === 'taller')
                    .map((actividad, i) => (
                      <React.Fragment key={`taller-sabado-${i}`}>
                        <div className="hora">
                          {actividad.hora} - {(() => {
                            const [hora, minuto] = actividad.hora.split(':').map(Number);
                            const totalMin = hora * 60 + minuto + 60;
                            const horaFin = Math.floor(totalMin / 60);
                            const minutoFin = totalMin % 60;
                            return `${horaFin.toString().padStart(2, '0')}:${minutoFin.toString().padStart(2, '0')}`;
                          })()}
                        </div>
                        <div 
                          className="actividad taller"
                          onClick={() => setActividadSeleccionada(actividad)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="actividad-info">{actividad.ponente} – {actividad.nombre}</div>
                        </div>
                      </React.Fragment>
                    ))}
                </div>
              </div>
            </div>

            <div className="agenda-dia domingo">
              <p className="agenda-leyenda">Agenda sujeta a cambios</p>
              <h3>Domingo 03 de Agosto</h3>
              
              {/* Conferencias Domingo */}
              <div className="agenda-seccion">
                <h4>Conferencias</h4>
                <div className="agenda-lista">
                  {actividadesDomingo
                    .filter(actividad => actividad.tipo === 'conferencia')
                    .map((actividad, i) => (
                      <React.Fragment key={`conf-domingo-${i}`}>
                        <div className="hora">
                          {actividad.hora} - {(() => {
                            const [hora, minuto] = actividad.hora.split(':').map(Number);
                            const totalMin = hora * 60 + minuto + 30;
                            const horaFin = Math.floor(totalMin / 60);
                            const minutoFin = totalMin % 60;
                            return `${horaFin.toString().padStart(2, '0')}:${minutoFin.toString().padStart(2, '0')}`;
                          })()}
                        </div>
                        <div 
                          className="actividad conferencia"
                          onClick={() => setActividadSeleccionada(actividad)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="actividad-info">{actividad.ponente} – {actividad.nombre}</div>
                        </div>
                      </React.Fragment>
                    ))}
                </div>
              </div>

              {/* Talleres Domingo */}
              <div className="agenda-seccion">
                <h4>Talleres</h4>
                <div className="agenda-lista">
                  {actividadesDomingo
                    .filter(actividad => actividad.tipo === 'taller')
                    .map((actividad, i) => (
                      <React.Fragment key={`taller-domingo-${i}`}>
                        <div className="hora">
                          {actividad.hora} - {(() => {
                            const [hora, minuto] = actividad.hora.split(':').map(Number);
                            const totalMin = hora * 60 + minuto + 60;
                            const horaFin = Math.floor(totalMin / 60);
                            const minutoFin = totalMin % 60;
                            return `${horaFin.toString().padStart(2, '0')}:${minutoFin.toString().padStart(2, '0')}`;
                          })()}
                        </div>
                        <div 
                          className="actividad taller"
                          onClick={() => setActividadSeleccionada(actividad)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="actividad-info">{actividad.ponente} – {actividad.nombre}</div>
                        </div>
                      </React.Fragment>
                    ))}
                </div>
              </div>
            </div>
          </>
        )}
        {/* Sección Zona Felina */}
        {SHOW_AGENDA && actividadesZonaFelina && actividadesZonaFelina.length > 0 && (
          <div className="agenda-dia zona-felina" id="zona-felina">
            <p className="agenda-leyenda">Zona Felina - Agenda sujeta a cambios</p>
            <div style={{textAlign: 'center', fontWeight: 'bold', marginBottom: '0.5em'}}>La misma agenda aplica para sábado y domingo</div>
            <h3>Zona Felina</h3>
            <div className="agenda-seccion">
              <h4>Charlas</h4>
              <div className="agenda-lista">
                {actividadesZonaFelina.map((actividad, i) => (
                  <React.Fragment key={`zona-felina-${i}`}>
                    <div className="hora">
                      {actividad.hora} - {(() => {
                        const [hora, minuto] = actividad.hora.split(':').map(Number);
                        const totalMin = hora * 60 + minuto + 45;
                        const horaFin = Math.floor(totalMin / 60);
                        const minutoFin = totalMin % 60;
                        return `${horaFin.toString().padStart(2, '0')}:${minutoFin.toString().padStart(2, '0')}`;
                      })()}
                    </div>
                    <div 
                      className="actividad zona-felina"
                      onClick={() => setActividadSeleccionada({ ...actividad, zonaFelina: true })}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="actividad-info">{actividad.ponente} – {actividad.nombre}</div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        )}

        {SHOW_REGISTRO && (
          <section id="registro" className="registro">
            <h2>Registro</h2>
            <RegistroForm 
              onSubmit={() => console.log('Registro enviado')} 
              actividadesSabado={actividadesSabado}
              actividadesDomingo={actividadesDomingo}
            />
          </section>
        )}

        {SHOW_PRESENTADO && (
          <section className="presentado">
            <h2>Presentado por:</h2>
            <br></br>
            <div className="logos">
              {/* Primera fila: logos principales */}
              <div className="logos-principales">
                {/* <img 
                  src="/img/presentado/royal-blanco.png" 
                  alt="royal" 
                  className="logo-presentado-principal"
                /> */}
              </div>
              {/* Segunda fila: Todos los demás logos, BBF un poco más grande */}
              <div className="logos-secundarios">
                {logosPresentado.map(logo => (
                  <div className="logo-secundario-box" key={logo}>
                    <img 
                      src={`/img/presentado/${logo}`} 
                      alt={logo.split('.')[0].replace('-', ' ')} 
                      className={logo === 'bbf-blanco.png' || logo === 'infinity.png' ? 'logo-presentado-mediano' : ''}
                    />
                  </div>
                ))}
              </div>
            </div>
            <br></br><h2>Asociaciones:</h2><br></br>
            <div className="logos">
              {logosAsociaciones.map(logo => (
                <img 
                  key={logo} 
                  src={`/img/asociaciones/${logo}`} 
                  alt={logo.split('_')[0].replace('-', ' ')} 
                  className={['18a_BLANCO.png', 'firma-dorada_BLANCO.png', 'logo-unam_BLANCO.png', 'logo-fmvz_BLANCO.png', 'USAR-MARINA.png'].includes(logo) ? 'logo-asociacion-grande' : ''}
                />
              ))}
            </div>
          </section>
        )}

        <footer className="footer">
          <div className="footer-main">
            <div className="footer-col footer-logo">
              <div className="footer-evento-row">
                <img src="/img/logo-blanco.png" alt="Logo Amores de Garra" className="footer-logo-img" />
                <div className="footer-evento-ano-datos">
                  <div className="footer-evento-datos">
                    <div className="footer-evento-fecha"><strong>17 y 18 de octubre</strong></div>
                    <div className="footer-evento-nombre"><strong>Explanada de la Alcaldía<br/>Benito Juárez</strong><br/>Ciudad de México</div>
                  </div>
                </div>
              </div>
            </div>
           {/*  <div className="footer-col footer-redes">
              <div className="footer-redes-title">Síguenos en redes sociales:</div>
              <div className="footer-redes-icons">
                <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
                <a href="https://tiktok.com/" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><i className="fab fa-tiktok"></i></a>
                <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
                <a href="#" aria-label="X"><i className="fab fa-x-twitter"></i></a>
              </div>
            </div> */}
            <div className="footer-col footer-contacto">
              <div className="footer-contacto-title">Contacto:</div>
              <div className="footer-contacto-info">
                {/*   <div>Correo: contacto@amoresdegarra.com</div>
                <div>Teléfono: 55 5303 2100</div> */}
              </div>
              <div className="footer-redes-title" style={{marginTop: '1.2rem'}}>Síguenos en redes sociales:</div>
              <div className="footer-redes-icons">
                <a href="https://www.instagram.com/amoresdegarra/?hl=es" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="https://x.com/AmoresGarra?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank" rel="noopener noreferrer" aria-label="X"><i className="fab fa-x-twitter"></i></a>
                <a href="https://www.facebook.com/amoresdegarra/?locale=es_LA" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
                <a href="https://open.spotify.com/show/3AI9gfTJYdHPF5ALUBrHmp" target="_blank" rel="noopener noreferrer" aria-label="Spotify"><i className="fab fa-spotify"></i></a>
                <a href="https://music.amazon.com.mx/podcasts/e4faee9f-3502-4d30-8503-3e5e47658a10/amores-de-garra" target="_blank" rel="noopener noreferrer" aria-label="Amazon"><i className="fab fa-amazon"></i></a>
                <a href="https://www.youtube.com/channel/UC4TbZM1Y1DFSZy0tgS8cnFg" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-copy">© 2026 Amores de Garra Fest. Todos los derechos reservados.</div>
            <div className="footer-legales">
              <a href="https://mvsnoticias.com/p/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>
              {/* <a href="#">Términos y condiciones</a> */}
            </div>
          </div>
        </footer>
      </main>

      {ponenteSeleccionado && (
        <div className="ponente-popup-overlay" onClick={cerrarPopupPonente}>
          <div className="ponente-popup" onClick={e => e.stopPropagation()}>
            <button className="cerrar-popup" onClick={cerrarPopupPonente}>&times;</button>
            <div className="popup-content">
              <div className="popup-foto" style={{ backgroundColor: ponenteSeleccionado.color }}>
                <img 
                  src={ponenteSeleccionado.foto} 
                  alt={ponenteSeleccionado.nombre}
                  onError={(e) => handleImageError(e, ponenteSeleccionado.nombre)}
                />
                <div className="popup-foto-placeholder" style={{display: 'none'}}>
                  <span>{ponenteSeleccionado.nombre.charAt(0)}</span>
                </div>
              </div>
              <div className="popup-info">
                <h3>{ponenteSeleccionado.nombre}</h3>
                <h4>{ponenteSeleccionado.profesion}</h4>
                <p>{procesarTextoConSaltos(ponenteSeleccionado.resumen)}</p>
                {/* Redes sociales comentadas por ahora
                <div className="popup-redes">
                  {ponenteSeleccionado.instagram && (
                    <a href={ponenteSeleccionado.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                  )}
                  {ponenteSeleccionado.facebook && (
                    <a href={ponenteSeleccionado.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
                  )}
                  {ponenteSeleccionado.tiktok && (
                    <a href={ponenteSeleccionado.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok"><i className="fab fa-tiktok"></i></a>
                  )}
                  {ponenteSeleccionado.youtube && (
                    <a href={ponenteSeleccionado.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
                  )}
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
      )}

      {actividadSeleccionada && (
        <div className="ponente-popup-overlay" onClick={() => setActividadSeleccionada(null)}>
          <div className="ponente-popup" onClick={e => e.stopPropagation()}>
            <button 
              className="cerrar-popup" 
              onClick={() => setActividadSeleccionada(null)}
              aria-label="Cerrar detalle de actividad"
            >
              &times;
            </button>
            <div className="popup-content">
              {/* Buscar el ponente por nombre */}
              {(() => {
                const nombreBuscado = actividadSeleccionada.ponente?.trim();
                const ponenteEncontrado = ponentesData.find(p => 
                  p.nombre.trim() === nombreBuscado ||
                  p.nombre.toLowerCase().trim() === nombreBuscado?.toLowerCase()
                );
                return (
                  <>
                    {ponenteEncontrado && (
                      <div className="popup-foto" style={{ backgroundColor: ponenteEncontrado.color }}>
                        <img 
                          src={ponenteEncontrado.foto} 
                          alt={ponenteEncontrado.nombre}
                          onError={(e) => handleImageError(e, ponenteEncontrado.nombre)}
                        />
                        <div className="popup-foto-placeholder" style={{display: 'none'}}>
                          <span>{ponenteEncontrado.nombre.charAt(0)}</span>
                        </div>
                      </div>
                    )}
                    <div className="popup-info">
                      <h3>{actividadSeleccionada.nombre}</h3>
                      <h4>{actividadSeleccionada.ponente || 'Por confirmar'}</h4>
                      <div className="actividad-detalles">
                        <p><strong>Tipo:</strong> {actividadSeleccionada.zonaFelina ? 'Zona Felina (45 min)' : actividadSeleccionada.tipo === 'conferencia' ? 'Conferencia (30 min)' : 'Taller (1 hora)'}</p>
                        <p><strong>Hora:</strong> {actividadSeleccionada.hora}</p>
                      </div>
                      {ponenteEncontrado && ponenteEncontrado.resumen && (
                        <div className="ponente-resumen">
                          <h4>Sobre el ponente:</h4>
                          <p>{procesarTextoConSaltos(ponenteEncontrado.resumen)}</p>
                        </div>
                      )}
                      {actividadSeleccionada.descripcion && (
                        <div className="actividad-descripcion">
                          <h4>Descripción de la actividad:</h4>
                          <p>{actividadSeleccionada.descripcion}</p>
                        </div>
                      )}
                    </div>
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
